/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const PlusIcon = createIcon({
  displayName: "PlusIcon",
  viewBox: "0 0 14 14",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74963 7.7506H11.6565V6.2506H7.74963V2.34375H6.24963L6.24963 6.2506H2.34277L2.34277 7.7506H6.24963V11.6575H7.74963L7.74963 7.7506Z"
        fill="currentColor"
      />
    </g>
  )
});
